import { ArrowUpRight } from "lucide-react";
import { toast } from "sonner";
import { useLang } from "../../i18n";
import { Reveal, Overline } from "./Reveal";
import { IMAGES, ORDER_LINK } from "../../data";

export const Order = () => {
  const { t } = useLang();

  const handleOrder = () => {
    if (ORDER_LINK) {
      window.open(ORDER_LINK, "_blank", "noopener,noreferrer");
    } else {
      toast(t.order.comingSoon, { duration: 6000 });
    }
  };

  return (
    <section id="order" data-testid="order-section" className="relative overflow-hidden bg-ink">
      <div className="grid grid-cols-1 items-center lg:grid-cols-2">
        <div className="relative flex flex-col justify-center px-6 py-20 md:px-14 lg:py-32">
          <Reveal>
            <Overline dark>{t.order.overline}</Overline>
            <h2 className="mt-5 font-serif text-4xl font-medium leading-[1.05] tracking-tight text-cream md:text-6xl">
              {t.order.title}
            </h2>
            <p className="mt-6 max-w-md leading-relaxed text-cream/65">{t.order.text}</p>
          </Reveal>
          <Reveal delay={0.15}>
            <button
              onClick={handleOrder}
              data-testid="order-online-btn"
              className="group mt-10 inline-flex w-fit items-center gap-3 bg-gold px-9 py-4 text-[12px] font-semibold uppercase tracking-[0.2em] text-ink transition-colors duration-500 hover:bg-cream"
            >
              {t.order.cta}
              <ArrowUpRight size={16} className="transition-transform duration-500 group-hover:-translate-y-0.5 group-hover:translate-x-0.5" />
            </button>
            <p className="mt-4 text-xs italic text-cream/40">{t.order.note}</p>
          </Reveal>
        </div>

        <button
          onClick={handleOrder}
          data-testid="order-image-link"
          aria-label={t.order.cta}
          className="group relative block h-full w-full cursor-pointer"
        >
          <img
            src={IMAGES.ordering}
            alt="A festival guest with her panettone"
            loading="lazy"
            className="block w-full transition-transform duration-700 ease-out group-hover:scale-[1.02]"
          />
        </button>
      </div>
    </section>
  );
};
